export default "__VITE_ASSET__68e47d1d__"